module.exports = __webpack_public_path__ + "media/logo/white-on-black-square-37869ff0.png";